import { Avatar, AvatarFallback, Icon } from "@elaniintc/goes-design-system";

// Shared "changes saved" toast payload used across the data-center detail view.
export const savedChangesToast = {
  title: "Cambios guardados",
  description: "Los cambios realizados en la tabla se guardaron correctamente.",
  options: {
    type: "success" as const,
    duration: 5000,
    customIcon: (
      <Avatar size="xs" shape="square">
        <AvatarFallback color="action" shape="square" type="icon">
          <Icon type="fas" name="save" />
        </AvatarFallback>
      </Avatar>
    ),
  },
};
